// src/composables/useToast.js
import { ref } from 'vue'

const toastMessage = ref('')
let toastTimeout = null

function showToast(message, duration = 5000) {
  toastMessage.value = message
  clearTimeout(toastTimeout)
  toastTimeout = setTimeout(() => {
    toastMessage.value = ''
  }, duration)
}

export function useToast() {
  return {
    toastMessage,
    showToast,
  }
}
